import { Box, Icon, Typography } from "@outschool/backpack";
import { getFundingProgramProperties } from "@outschool/funding-programs-shared";
import { CreditAccountState } from "@outschool/gql-frontend-generated";
import { PricingBreakdownQueryQuery } from "@outschool/gql-frontend-generated/src";
import { faInfoCircle } from "@outschool/icons";
import { useTranslation } from "@outschool/localization";
import React from "react";

export const EsaEnrollmentIneligibleAlert = ({
  pricingBreakdown
}: {
  pricingBreakdown: PricingBreakdownQueryQuery["pricingBreakdown"];
}) => {
  const { t } = useTranslation(
    "client\\components\\enrolling\\EsaEnrollmentIneligibleAlert"
  );
  const fundingProgramProperties = getFundingProgramProperties(
    pricingBreakdown?.esaMembershipFundingProgram
  );
  const fundingProgramName = !!fundingProgramProperties
    ? fundingProgramProperties?.programNameAbbr
    : t("your public funding program");

  if (
    pricingBreakdown.esaMembershipAccountState !==
    CreditAccountState.InvalidClassNotApprovedForProgram
  ) {
    return <></>;
  }

  return (
    <Box sx={{ display: "flex", alignItems: "start", marginTop: 8 }}>
      <Icon
        icon={faInfoCircle}
        sx={{
          color: "info.600",
          fontSize: "1.4rem",
          marginTop: 4,
          marginRight: 4
        }}
      />
      <Box sx={{ lineHeight: 0 }}>
        <Typography variant="body2" emphasized>
          {t("This class isn’t {{fundingProgramName}}-eligible. ", {
            fundingProgramName
          })}
        </Typography>
        <Typography variant="body2">
          {t("You can still enroll using a different payment method.")}
        </Typography>
      </Box>
    </Box>
  );
};
